import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  OpcionesPersonalizadoTipoCampo,
  Personalizados,
} from '@pages/utils/dynamic-form';
import { environment } from 'src/environments/environment';

@Injectable()
export class CamposPersonalizadosService {
  constructor(private _http: HttpClient) {}

  getPersonalizadosEstablecimiento() {
    return this._http.get<Personalizados[]>(
      `${environment.API_URL}/PersonalizadosEstablecimiento/`
    );
  }

  putPersonalizadosEstablecimiento(id: number, data: Personalizados) {
    return this._http.put(
      `${environment.API_URL}/PersonalizadosEstablecimiento/${id}`,
      data
    );
  }

  deletePersonalizadosEstablecimiento(id: number) {
    return this._http.delete(
      `${environment.API_URL}/PersonalizadosEstablecimiento/${id}`
    );
  }

  getTipoCampo() {
    return this._http.get<OpcionesPersonalizadoTipoCampo[]>(
      `${environment.API_URL}/TipoCampo/`
    );
  }

  getPersonalizadosEstablecimientoById(id: number) {
    return this._http.get<Personalizados>(
      `${environment.API_URL}/PersonalizadosEstablecimiento/${id}`
    );
  }

  postPersonalizadosEstablecimiento(data: Personalizados) {
    return this._http.post(
      `${environment.API_URL}/PersonalizadosEstablecimiento`,
      data
    );
  }
}
